export default __webpack_public_path__ + "static/team-Vinny-3d0e5d25750960c02e9b7441f355e1d4.png";